import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from 'react-router-dom';
import { useGetEventsQuery, useDeleteEventMutation } from './eventsApiSlice';
import { memo } from 'react';
import { Spinner } from "react-bootstrap";
import { useSelector } from "react-redux"; // <-- useSelector को इंपोर्ट करें

const Event = ({ eventId, index }) => {

    // Redux स्टोर से pageNumber प्राप्त करें, EventList.jsx की तरह
    const { pageNumber = 1 } = useSelector((state) => state?.event || {}); 

    const { event } = useGetEventsQuery({ page: pageNumber }, { // <-- यहाँ `{ page: pageNumber }` पास करें
        selectFromResult: ({ data }) => ({
            event: data?.entities[eventId]
        }),
    });

    const [deleteEvent, {
        isLoading: isDeleting,
        isSuccess: isDelSuccess,
        isError: isDelError,
        error: delError
    }] = useDeleteEventMutation();

    const onDeleteEventClicked = async () => {
        if (window.confirm("क्या आप इस इवेंट को डिलीट करना चाहते हैं?")) {
            await deleteEvent({ id: eventId });
        }
    };
    
    const navigate = useNavigate();

    if (event) {
        const eventDate = new Date(event.date).toLocaleDateString('hi-IN', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });

        const handleEdit = () => navigate(`/dashboard/events/${eventId}`);

        return (
            <>
                <tr className="table__row">
                    <td className="table__cell">{index + 1}</td>
                    <td className="table__cell">{event.name}</td>
                    <td className="table__cell">{event.organizer}</td>
                    <td className="table__cell">{eventDate}</td>
                    <td className="table__cell">{event.time}</td>
                    <td className="table__cell">{event.place}</td>
                    <td className="table__cell">{event.eventType}</td>
                    <td className="table__cell">
                        {event.zoomLink ? (
                            <a href={event.zoomLink} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                                लिंक
                            </a>
                        ) : 'N/A'}
                    </td>
                    <td className="table__cell">
                        {event.googleMapUrl ? (
                            <a href={event.googleMapUrl} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                                लिंक
                            </a>
                        ) : 'N/A'}
                    </td>
                    <td className="table__cell">
                        {event.banner && event.banner.url ? (
                            <img src={event.banner.url} alt="Event Banner" style={{width:100}} className="w-20 h-10 object-cover rounded" />
                        ) : (
                            'कोई बैनर नहीं'
                        )}
                    </td>
                    <td className="table__cell">
                        <button
                            className="icon-button table__button mr-2"
                            onClick={handleEdit}
                        >
                            <FontAwesomeIcon icon={faPenToSquare} />
                        </button>
                        <button
                            className="icon-button table__button text-red-600"
                            onClick={onDeleteEventClicked}
                            disabled={isDeleting}
                        >
                            {isDeleting ? <Spinner animation="border" size="sm" /> : <FontAwesomeIcon icon={faTrashCan} />}
                        </button>
                    </td>
                </tr>
                {isDelError && (
                    <tr>
                        <td colSpan={10} className="errmsg text-center">
                            {delError?.data?.message || "इवेंट डिलीट करने में त्रुटि।"}
                        </td>
                    </tr>
                )}
            </>
        )
    } else return null
}

const memoizedEvent = memo(Event)

export default memoizedEvent;